const state =  {
    fullName: '',
    avatar: '',
    firstTimeInApp:false
}

const getters = {

}

const actions = {

}

const mutations = {
    updateFullName(state, fullName) {
        state.fullName = fullName;
    },
    updateAvatar(state, avatar) {
        state.avatar = avatar;
    },
    updateFirstTimeInApp(state, firstTimeInApp) {
        state.firstTimeInApp = firstTimeInApp;
    }
}

export const user = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
